import type { WelcomePost } from '../types'
import { getCommonWelcomePostPayload } from './getCommonWelcomePostPayload'

export const getTextWelcomePostPayload = (welcomePost: WelcomePost) => {
  return {
    type: 'Text',
    attributes: getCommonWelcomePostPayload(welcomePost),
  }
}
